import React from "react";

import { prettyPrice } from '../utils';

const CartItemDiscounts = ({ item, couponCode, couponApplied }) => {
  if (item.isDiscounted()) {
    return (
      <p className="savings">
        {item.price !== item.finalPrice() ? (
          <>
            <span className="strikethrough">${ prettyPrice(item.price) }</span>
            <span className="red">${ prettyPrice(item.finalPrice()) }</span>
            <span>({ item.discountingMessage() })</span>
          </>
        ) : (<span className="savings">{ item.discountingMessage() }</span>)
        }
      </p>
    );
  }

  if (couponApplied) {
    return (
      <p>Coupon { couponCode } not valid for this product</p>
    );
  }

  return null;
};

export default CartItemDiscounts;
